import { render, staticRenderFns } from "./CChartBarSimple.vue?vue&type=template&id=318e4509&"
import script from "./CChartBarSimple.vue?vue&type=script&lang=js&"
export * from "./CChartBarSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports